import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useBallCounts } from '../../hooks/useBallCounts';
import BallsDisplay from '../BallsDisplay';
import BallEditDrawer from '../BallEditDrawer';
import QuickPickButtons from '../QuickPickButtons';
import classes from './BetTicket.module.scss';

const BetTicketBallSelection = ({
  ticket,
  balls,
  onBallsChange,
  onValidationError,
  isDrawerOpen,
  onDrawerOpen,
  onDrawerClose,
}) => {
  const hasAutoOpenedRef = useRef(false);
  const [hasMounted, setHasMounted] = useState(false);

  const hasBalls = ticket.balls != null && ticket.balls.length > 0;
  const { minNormalCount, maxNormalCount, requiredBonusCount } = useBallCounts({
    hasBalls,
    marketType: ticket.market_type,
    balls: ticket.balls,
    mainGridTotal: ticket.main_grid_total,
    editedNumbers: balls,
  });

  const handleConfirm = useCallback(
    (numbers) => {
      onBallsChange(numbers);
      onValidationError(null);
      onDrawerClose();
    },
    [onBallsChange, onValidationError, onDrawerClose]
  );

  useEffect(() => {
    setHasMounted(isDrawerOpen);
  }, [isDrawerOpen]);

  useEffect(() => {
    if (ticket.initialEditMode && !hasAutoOpenedRef.current) {
      onDrawerOpen();
      hasAutoOpenedRef.current = true;
    }
  }, [ticket.initialEditMode, onDrawerOpen]);

  return (
    <div className={classes.BallSelection}>
      <div className={classes.BallsContainer}>
        <BallsDisplay
          numbers={balls}
          size="medium"
          showEditButton
          onEditClick={onDrawerOpen}
        />
      </div>

      <QuickPickButtons
        ticket={ticket}
        editedNumbers={balls}
        setEditedNumbers={onBallsChange}
        setValidationError={onValidationError}
        minNormalCount={minNormalCount}
        requiredBonusCount={requiredBonusCount}
        lotteryId={ticket.draw_id}
      />

      {hasMounted && (
        <BallEditDrawer
          open={isDrawerOpen}
          onClose={onDrawerClose}
          onConfirm={handleConfirm}
          selectedNumbers={balls}
          mainGridTotal={ticket.main_grid_total}
          secondaryGridTotal={ticket.secondary_grid_total}
          secondaryUnique={ticket.secondary_unique}
          minNormalCount={minNormalCount}
          maxNormalCount={maxNormalCount}
          requiredBonusCount={requiredBonusCount}
          ticket={ticket}
          onValidationError={onValidationError}
        />
      )}
    </div>
  );
};

export default BetTicketBallSelection;
